import {Box} from "@mui/material";
import React from "react";

/** A status's colored dot, the start icon of its chip beside the words - never color alone. */
export function StatusDot({color}: {color: string}) {
    return (
        <Box
            component="span"
            sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                bgcolor: color,
                flex: "0 0 auto",
            }}
        />
    );
}
